'use strict';

angular.module('amexReconciliationApp')
  .component('advancedSearchModal', {
    templateUrl: 'scripts/views/components/advanced-search-modal.html',
    bindings: {
      closeModalCallback: '&'
    },
    controller: function ($translate,
                          SearchModel,
                          TransactionTabFilterModel,
                          TransactionsModel,
                          AnalyticsService,
                          SiteConfigModel,
                          advancedSearch) {

      var self = this;

      self.$onInit = function () {
        self.closeModal = self.closeModalCallback;
        self.savedSearches = SearchModel.savedSearches;
        self.currentSearch = {};
        self.fieldTypes = SearchModel.getFields();

        SearchModel.loadDefaultSearches();
        self.resetSearch();
        if (!_.isEmpty(_.get(SearchModel.activeSearch(), 'criteria', []))) {
          self.currentSearch = _.cloneDeep(SearchModel.activeSearch());
        }

        self.searchCountFlag = false;
      };
      
      self.search = function () {
        if (TransactionsModel.transactionCount() > TransactionsModel.maxTransactions()) {
          SearchModel.allBackEndSearchCount(self.currentSearch)
            .then(function() {
              updateSearchCountFields();
              if (!self.searchCountFlag) {
                SearchModel.search(self.currentSearch);
                TransactionTabFilterModel.activeTab('search-results');
                self.closeModal();
              }
            });
        } else {
          SearchModel.search(self.currentSearch);
          TransactionTabFilterModel.activeTab('search-results');
          self.closeModal();
        }

        AnalyticsService.logAdvancedSearchUsage();
      };

      self.saveSearch = function() {
        SearchModel.saveSearch(self.currentSearch);
      };

      self.deleteSearch = SearchModel.deleteSavedSearch;
      
      self.addCriterion = function(criterion) {
        if (!self.disableAdd()) {
          var index = self.getCriteria().indexOf(criterion);
          self.getCriteria().splice(index + 1, 0, _.cloneDeep(criterion));
        }
      };

      self.removeCriterion = function(criterion) {
        var index = self.getCriteria().indexOf(criterion);
        self.getCriteria().splice(index, 1);
      };

      self.getCriteria = function() {
        return self.currentSearch.criteria;
      };

      self.selectSearch = function (search) {
        self.currentSearch = SearchModel.cloneSearch(search);
      };

      self.resetSearch = function () {
        self.currentSearch = {
          name: '',
          matchType: 'ALL',
          criteria: [{
            fieldType: '',
            fieldValue: {},
            operator: ''
          }]
        };
      };

      self.disableSaveSearchButton = function () {
        return self.disableSearchButton() || !self.currentSearch.name;
      };

      self.disableSearchButton = function () {
        return _.some(self.getCriteria(), self.isDefaultFieldType);
      };

      self.disableRemove = function () {
        return self.getCriteria().length < 2;
      };

      self.disableAdd = function () {
        return self.getCriteria().length >= advancedSearch.MAX_SEARCH_CRITERIA;
      };

      self.isDefaultFieldType = function (criterion) {
        return !criterion.fieldType || criterion.fieldType === '';
      };

      self.matchType = function(newVal) {
        if(arguments.length === 1) {
          self.currentSearch.matchType = newVal ? 'ANY' : 'ALL';
        } else {
          return _.isEqual(self.currentSearch.matchType, 'ANY');
        }
      };

      function updateSearchCountFields() {
        self.searchCount = SearchModel.searchCount;
        self.searchCountFlag = SearchModel.searchCount >= TransactionsModel.maxTransactions();

        var parameters = {
          searchCount: self.searchCount,
          totalCount: TransactionsModel.transactionCount(),
          limit: TransactionsModel.maxTransactions()
        };
        self.searchCountMessage = $translate.instant('transactions.search.TooManyTransactions', parameters );
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/advancedSearchModal.js
// module id = 432
// module chunks = 0